import { render, staticRenderFns } from "./DownloadDialog.vue?vue&type=template&id=c2a3568a&scoped=true"
import script from "./DownloadDialog.vue?vue&type=script&lang=js"
export * from "./DownloadDialog.vue?vue&type=script&lang=js"
import style0 from "./DownloadDialog.vue?vue&type=style&index=0&id=c2a3568a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a3568a",
  null
  
)

export default component.exports